<template>

  <div>

    <TemplateLoading v-show="feedbackLoading" />

    <TemplateAlert 
      v-bind:error="feedbackError" 
      v-bind:message="feedbackMessage"
      v-bind:warning="feedbackWarning" />

  </div>
  
</template>

<script>

import TemplateAlert from "@/components/Template/TemplateAlert";
import TemplateLoading from "@/components/Template/TemplateLoading";

var axios = require('axios');

export default {
  name: "TemplateFeedback",
  components: {
    TemplateAlert,
    TemplateLoading,
  },
  data() {
    return {
      feedbackLoading: false,
      feedbackError: null,
      feedbackMessage: null,
      feedbackWarning: null,
    };
  },
  methods: {
    setFeedbackLoading(message) {
      this.feedbackLoading = true;
      this.feedbackError = null;
      this.feedbackMessage = message || 'Loading...';
      this.feedbackWarning = null;
    },
    setFeedbackError(error) {
      // TODO kw prevent axios cancel error message from changing page state
      // helpful when loading last piece, actual data for page
      if(axios.isCancel(error)) {
        return;
      }
      
      this.feedbackLoading = false;
      this.feedbackError = error;
      this.feedbackMessage = null;
      this.feedbackWarning = null;
    },
    setFeedbackMessage(message) {
      this.feedbackLoading = false;
      this.feedbackError = null;
      this.feedbackMessage = message;
      this.feedbackWarning = null;
    },
    setFeedbackWarning(message) {
      this.feedbackLoading = false;
      this.feedbackError = null;
      this.feedbackMessage = null;
      this.feedbackWarning = message;
    },
  },
};

</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateFeedback.vue